// Pathfinder Unchained Variant Multiclassing — Bard archetype benefit tiers.
const bardArchetype = [
  {
    level: 3,
    name: 'Bardic Knowledge',
    description: 'You gain the bardic knowledge class feature, treating your character level as your effective bard level.',
  },
  {
    level: 7,
    name: 'Bardic Performance',
    description: 'You gain the ability to inspire courage and inspire competence as a bard of your character level – 4, for a number of rounds per day equal to your Charisma modifier + your character level.',
  },
  {
    level: 11,
    name: 'Versatile Performance',
    description: 'You gain versatile performance in one Perform skill of your choice. You can retrain all your ranks in the two associated skills for free.',
  },
  {
    level: 15,
    name: 'Lore Master',
    description: 'You gain lore master as a 5th-level bard.',
  },
  {
    level: 19,
    name: 'Additional Performances',
    description: 'You gain the ability to use dirge of doom and inspire greatness as a bard of your character level – 4.',
  },
];

export default bardArchetype;
